// components/ChatInput.jsx
import React from "react";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";

function ChatInput({
  ref,
  query,
  onSend,
  setQuery,
  writingLoading,
  disabled = false,
  hideSendButton = false,
  chatPlaceholder = "Ask AI something...",
}) {

  const handleChange = (e) => {
    setQuery(e.target.value);
  };

  const handleKeyUp = (e) => {
    if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
      e.preventDefault();
      setQuery((prevText) => prevText + '\n');
    } else if ((e.shiftKey || e.metaKey) && e.key === 'Enter') {
      e.preventDefault();
    } else {
      if (e.key === 'Enter') {
        if (!disabled) onSend(query);
      }
    }
  };

  return (
    <div className="position-relative chat-input flex-column p-3">
      <textarea
        ref={ref}
        value={query}
        autoFocus={true}
        onKeyUp={handleKeyUp}
        onChange={handleChange}
        readOnly={writingLoading}
        placeholder={chatPlaceholder}
      ></textarea>
      {!hideSendButton && (
        <div className="chat-actions">
          <div className="chat-actions-left">
            {/* <OverlayTrigger placement="top" overlay={<Tooltip>Attach Files</Tooltip>}>
            <span className={writingLoading && 'disabled'}><i className="icon-attachment"></i></span>
          </OverlayTrigger> */}
            {/* <OverlayTrigger placement="top" overlay={<Tooltip>Add More</Tooltip>}>
            <span className={writingLoading && 'disabled'}><i className="icon-plus"></i></span>
          </OverlayTrigger> */}
          </div>
          <div className="chat-actions-right">
            {/* <OverlayTrigger placement="top" overlay={<Tooltip>Quick options</Tooltip>}>
              <span className={writingLoading && 'disabled'}><i className="icon-bar-listing"></i></span>
            </OverlayTrigger> */}
            <button className="send-btn" onClick={() => onSend(query)} disabled={disabled}>
              <i className="icon-arrow-up"></i>
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default ChatInput;